import { render, staticRenderFns } from "./BromleyCity.vue?vue&type=template&id=4ca08ad4&scoped=true&"
import script from "./BromleyCity.vue?vue&type=script&lang=js&"
export * from "./BromleyCity.vue?vue&type=script&lang=js&"
import style0 from "./BromleyCity.vue?vue&type=style&index=0&id=4ca08ad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca08ad4",
  null
  
)

export default component.exports